import jQuery from 'jquery';
import svg4everybody from 'svg4everybody';
import fluidvids from './components/fluidvids';
import '../style/main.scss';
import './components/carousel';
import './components/tabbed-content';
import './components/slider';
import './components/shop-images';
import './components/form';
import './components/stats';
import './components/fab-donate';
import './components/navigation';
import './components/xmas-cracker';
import './components/thermometer';
import './components/stripe-donation';
import './components/missions-explorer';

window.$ = window.jQuery = jQuery;

if (module.hot) {
  module.hot.accept();
}

function requireAll(r) {
  r.keys().forEach(r);
}

requireAll(require.context('../static/icons/', true, /\.svg$/));

const w = window;
const d = document;
const body = d.querySelector('body');
const hamburgerLink = d.querySelector('.hamburger-button');
const closeLink = d.querySelector('.close-button');

if (hamburgerLink && closeLink) {
  hamburgerLink.addEventListener('click', openMenu);
  closeLink.addEventListener('click', closeMenu);
}

function openMenu(event) {
  body.classList.add('menu-active');
  console.log('toggle on');
  event.stopPropagation();
  d.addEventListener('click', clickAway);
  d.addEventListener('keyup', escapeMenu);
}
function closeMenu(event) {
  console.log('toggle off');
  body.classList.remove('menu-active');
  d.removeEventListener('click', clickAway);
  d.removeEventListener('keyup', escapeMenu);
}

function clickAway(event) {
  if ($(event.target).closest('.header__navigation').length) return;
  closeMenu(event);
}

function escapeMenu(event) {
  if (event.keyCode === 27) closeMenu(); // esc
}

export default class main {
  static init() {
    svg4everybody({ polyfill: true });
    fluidvids.init({
      selector: ['iframe'],
      players: ['www.youtube.com', 'player.vimeo.com', 'www.google.com'],
    });
  }
}

main.init();
